import { isJigsawOnly } from '../redux-watson/watson-config-selectors';
import {
  isJigsawSessionPending,
  isLoggedInToJigsaw,
} from '../redux-jigsaw/user-info-selectors';
import {
  isBridgeSessionPending,
  isLoggedInToBridge,
} from '../redux-bridge/session/selectors';
import { hasCookieError as hasJigsawCookieError } from '../redux-jigsaw/jigsaw-selectors';
import { hasCookieError as hasBridgeCookieError } from '../redux-bridge/session/selectors';

export function isLoggedIn(state) {
  if (isJigsawOnly(state)) {
    return isLoggedInToJigsaw(state);
  }
  return isLoggedInToBridge(state);
}

export function isSessionPending(state) {
  return isJigsawSessionPending(state) || isBridgeSessionPending(state);
}

export function hasCookieError(state) {
  return hasJigsawCookieError(state) || hasBridgeCookieError(state);
}
